import React from "react";
import { Redirect } from "react-router-dom";
import i18next from "i18next";

import fr_CA from "./i18n/fr_CA";
import en_CA from "./i18n/en_CA";

i18next.addResourceBundle("fr-CA", "billetsApp", fr_CA);
i18next.addResourceBundle("en-CA", "billetsApp", en_CA);

export const BilletsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  name: "Billets",
  auth: "billets_management",
  routes: [
    {
      path: "/app/billets/edit/:billetId",
      component: React.lazy(() => import("./views/Edit")),
    },
    {
      path: "/app/billets/view/:billetId",
      component: React.lazy(() => import("./views/View")),
    },
    {
      path: "/app/billets",
      component: React.lazy(() => import("./views/List")),
    },
    {
      path: "/app/billets*",
      component: () => <Redirect to="/app/billets" />,
    },
  ],
};

